import { render, staticRenderFns } from "./UpgradeTeamPlanModal.vue?vue&type=template&id=5e22d971&scoped=true&"
import script from "./UpgradeTeamPlanModal.vue?vue&type=script&lang=js&"
export * from "./UpgradeTeamPlanModal.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeTeamPlanModal.vue?vue&type=style&index=0&id=5e22d971&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e22d971",
  null
  
)

export default component.exports